<template>
  <div id="app" :class="[navOpen ? 'nav-open' : '', schedOpen ? 'sched-open' : '', quotesOpen ? 'quotes-open' : '']">
<!-- 	  <Header/> 
	  <Navigation/> -->
	  <Livestream/>
    
    <div class="mh">
        <router-view/>
    </div>
  
    <Footer />
    <div class="protect" @click="protectClick"></div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Navigation from './components/Navigation.vue'
import Livestream from './components/Livestream.vue'
import Footer from './components/Footer.vue'

import moment from 'moment'

export default {
  name: 'App',
  components: {
	  Header,
	  Navigation,
	  Livestream,
	  Footer
  },
  data() {
	  return {
	   
	  }
  },
  metaInfo: {
    titleTemplate: (titleChunk) => {
		  return titleChunk ? `${titleChunk} - Performa` : 'Performa';
		}
  },
  computed: {
    navOpen () {
      return this.$store.state.navOpen
    },
    schedOpen () {
	    return this.$store.state.schedOpen
    },
    quotesOpen(){
      return this.$store.state.quotesOpen
    }
  },
  methods: {
    protectClick () {
      this.$store.dispatch('toggleSched')
    }
  },
  created () {
	  window.prerenderReady = false;
  },
  mounted: function () {
	  this.$nextTick(function () {
	    window.prerenderReady = true
	  })

    setInterval(function() {
      var broadtime = moment();
      var startTime = moment('Tue Oct 12 2021 18:00:00 GMT-0400');
      var endTime = moment('Tue Oct 12 2021 23:00:00 GMT-0400');
      let url = window.location.href;
      
      if (!url.includes("test")){
        if(!broadtime.isBetween(startTime, endTime)){
        window.location.href = "https://performa2021.org";
        }
      }
      

    }, 1000);
	}
}
</script>

<style scoped>
@import "./assets/css/prismic-edit-button.css";
@import "./assets/css/performa.css";

.fade-enter{
        opacity: 0;
    }
    .fade-enter-active{
        transition: opacity 250ms;
    }
    .fade-leave{
        /* opacity: 1; */
    }
    .fade-leave-active{
        transition: opacity 250ms;
        opacity: 0;
    }
</style>
